/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: add proper typings
import { getStake, isSAGFlashVariant, isSAGHoldemSix, isSAGMax } from './helpers';

export default function ImageSagGameFormatter({
  buyIn,
  currency,
  flags,
  mods,
  game,
  maxPrizePool,
  promoRef,
  rake,
  scalePM,
  isPlayMoney
}: any) {
  const isMax = isSAGMax(flags);
  const isFlash = isSAGFlashVariant(flags);
  const isHoldemSix = isSAGHoldemSix(game, flags, mods);
  const isHoldem = game === 2;
  const isOmaha = !isMax && !isFlash && !isHoldem;

  const stake = getStake({
    buyIn,
    currency,
    maxWinnerPayout: maxPrizePool,
    promoRef,
    rake,
    scalePM,
    isPlayMoney
  });

  const result = {
    holdem: isHoldem ? `spingo--holdem-${stake}` : '',
    flash: isFlash ? `spingo--flash-${stake}` : '',
    omaha: isOmaha ? `spingo--omaha-${stake}` : '',
    max: isMax ? `spingo--max-${stake}` : '',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'holdem-six': isHoldemSix ? `spingo--holdem-six-${stake}` : ''
  };
  return result;
}
